import apiRequestType from "../../apiRequestType";
import { apiConstants } from "../../../utils/apiConstants";
import { apiTypes } from "../../../utils/apiTypes";
import { getAxiosCancelToken } from "../../../utils/getAxiosCancelToken";

let cancelToken;

const getUserGroupClassUsageDetails = (
  classId,
  fromDate,
  toDate,
  userGroupId
) => {
  cancelToken = getAxiosCancelToken(cancelToken);
  return apiRequestType(
    apiTypes.GET,
    apiConstants.REPORT.ADOPTION_REPORT.GET_USERGROUP_CLASS_USAGE_DETAILS(
      classId,
      fromDate,
      toDate,
      userGroupId
    ),
    cancelToken
  );
};

export default getUserGroupClassUsageDetails;
